export enum CRUDTableActions {
  create,
  edit,
  multipleDelete,
}
